// KIMU 2.0 — Quiz engine
// -----------------------------------------

(function () {
  'use strict';

  const quiz = document.querySelector('[data-quiz]');
  if (!quiz) return;

  const steps = quiz.querySelectorAll('.quiz-step');
  const progress = quiz.querySelectorAll('.quiz-progress span');
  const nextBtn = quiz.querySelector('[data-quiz-next]');
  const prevBtn = quiz.querySelector('[data-quiz-prev]');
  const resultEl = quiz.querySelector('[data-quiz-result]');
  const productsData = JSON.parse(quiz.dataset.products || '[]');

  let current = 0;
  const answers = {};

  function show(idx) {
    steps.forEach((s, i) => s.classList.toggle('is-active', i === idx));
    progress.forEach((p, i) => p.classList.toggle('is-active', i <= idx));
    if (prevBtn) prevBtn.style.visibility = idx === 0 ? 'hidden' : 'visible';
    if (nextBtn) nextBtn.style.display = 'none';
    current = idx;
  }

  quiz.querySelectorAll('.quiz-option').forEach((opt) => {
    opt.addEventListener('click', () => {
      const step = opt.closest('.quiz-step');
      step.querySelectorAll('.quiz-option').forEach((o) => o.classList.remove('is-selected'));
      opt.classList.add('is-selected');
      answers[step.dataset.q] = opt.dataset.value;
      // Auto-advance: pequeño delay para que el usuario vea su selección, luego pasa
      setTimeout(() => {
        if (current < steps.length - 1) {
          show(current + 1);
        } else {
          finish();
        }
      }, 350);
    });
  });

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      const step = steps[current];
      if (!answers[step.dataset.q]) {
        alert('Elige una opción para seguir.');
        return;
      }
      if (current < steps.length - 1) {
        show(current + 1);
      } else {
        finish();
      }
    });
  }
  if (prevBtn) {
    prevBtn.addEventListener('click', () => { if (current > 0) show(current - 1); });
  }

  // q4 pregunta que EVITAR. Sus valores ('muy-dulce') nunca calzaban con las
  // etiquetas del producto ('dulce'), asi que la respuesta se ignoraba y el
  // quiz podia recomendar justo lo que la persona pidio evitar.
  const GENERO = {
    'mujer': 'mujer',
    'regalo-mujer': 'mujer',
    'hombre': 'hombre',
    'regalo-hombre': 'hombre',
    'unisex': null
  };

  const EVITAR = {
    'muy-dulce': ['dulce', 'gourmand', 'floral-gourmand'],
    'muy-citrico': ['citrico', 'cítrico', 'fresco'],
    'muy-floral': ['floral', 'floral-gourmand'],
    'muy-fuerte': ['intenso', 'noche', 'oriental', 'salir'],
    'ninguno': []
  };

  function score(product) {
    let pts = 0;
    const tags = (product.quiz_tags || []).map((t) => String(t).toLowerCase());
    const family = (product.family || '').toLowerCase();

    Object.entries(answers).forEach(([q, val]) => {
      if (q === 'q4') return; // se procesa aparte: resta, no suma
      if (tags.includes(String(val).toLowerCase())) pts += 2;
    });
    if (answers.q1 && family.includes(String(answers.q1).toLowerCase())) pts += 1;

    const evitar = EVITAR[answers.q4] || [];
    const choca = evitar.some((e) => tags.includes(e) || family.includes(e));
    if (choca) pts -= 100;

    // El genero tiene que filtrar, no sumar: pidiendo "para mi (mujer)" el quiz
    // podia devolver un perfume de hombre como mejor match. Los unisex entran siempre.
    const buscado = GENERO[answers.q5];
    const gen = (product.gender || '').toLowerCase();
    if (buscado && gen && gen !== 'unisex' && gen !== buscado) pts -= 100;
    if (buscado && gen === buscado) pts += 2;

    return pts;
  }

  function finish() {
    const scoredAll = productsData
      .map((p) => ({ ...p, score: score(p) }))
      .sort((a, b) => b.score - a.score)
      ;
    const scoredOk = scoredAll.filter((p) => p.score >= 0);
    const ranked = (scoredOk.length ? scoredOk : scoredAll).slice(0, 3);
    const quizFam = (ranked[0] && ranked[0].family) || '';

    const labels = ['Tu mejor match', 'Alternativa más suave', 'Alternativa más intensa'];
    resultEl.innerHTML = `
      <h2>Encontramos lo tuyo.</h2>
      <p style="color:var(--color-text-muted);max-width:50ch;margin:0 auto 2rem">Basado en tus respuestas, estos perfumes podrían quedarte muy bien. El tester 3 ml siempre incluido.</p>
      <div class="quiz-result__products">
        ${ranked.map((p, i) => `
          <a href="${p.url}" class="product-card" style="display:block">
            <span class="label">${labels[i] || 'Recomendación'}</span>
            <div class="product-card__media">
              <img src="${p.image}" alt="${p.title}" loading="lazy">
            </div>
            <div class="product-card__family">${p.family || ''}</div>
            <div class="product-card__title">${p.title}</div>
            <div class="product-card__notes">${p.notes || ''}</div>
            <div class="product-card__price">${p.price}</div>
          </a>
        `).join('')}
      </div>
      <div style="margin-top:3rem;display:flex;gap:0.75rem;justify-content:center;flex-wrap:wrap">
        <button class="btn btn-primary" data-quiz-add-decants>Agregar decants de estos aromas</button>
        <button class="btn btn-secondary" data-quiz-restart>Volver a hacer el quiz</button>
      </div>
      <form method="post" action="/contact#quiz-lead" id="quiz-lead" class="quiz-lead" accept-charset="UTF-8"><input type="hidden" name="form_type" value="customer"><input type="hidden" name="utf8" value="\u2713"><input type="hidden" name="contact[tags]" value="quiz,familia:${quizFam}"><p style="margin:0 0 .75rem;color:var(--color-text-muted)">Te guardamos tu perfil olfativo y te mandamos un 20% para tu primer KIMU.</p><div class="quiz-lead__row"><input type="email" name="contact[email]" placeholder="Tu correo" required class="field" aria-label="Correo electrónico"><button class="btn btn-primary" type="submit">Guardar mi perfil</button></div></form>
    `;
    steps.forEach((s) => s.classList.remove('is-active'));
    progress.forEach((p) => p.classList.add('is-active'));
    resultEl.hidden = false;
    if (nextBtn) nextBtn.hidden = true;
    if (prevBtn) prevBtn.hidden = true;


    // Agregar decants 3ml de los 3 perfumes recomendados y redirigir a checkout
    const addBtn = resultEl.querySelector('[data-quiz-add-decants]');
    if (addBtn) {
      addBtn.addEventListener('click', async () => {
        addBtn.disabled = true;
        const originalText = addBtn.textContent;
        addBtn.textContent = 'Agregando...';

        function decantHandle(title) {
          // 'Coffee Blossom' -> 'decant-coffee-blossom-3-ml'
          const slug = String(title || '').toLowerCase()
            .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
            .replace(/\s+/g, '-')
            .replace(/[^a-z0-9-]/g, '');
          return 'decant-' + slug + '-3-ml';
        }

        const items = [];
        for (const p of ranked) {
          const h = decantHandle(p.title);
          try {
            const r = await fetch('/products/' + h + '.js');
            if (r.ok) {
              const decant = await r.json();
              const variant = (decant.variants || []).find(v => v.available) || (decant.variants || [])[0];
              if (variant) items.push({ id: variant.id, quantity: 1 });
            }
          } catch (e) { /* skip */ }
        }

        if (items.length === 0) {
          addBtn.textContent = 'No encontramos decants disponibles';
          setTimeout(() => { addBtn.textContent = originalText; addBtn.disabled = false; }, 2500);
          return;
        }

        try {
          const r = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          });
          if (!r.ok) throw new Error('cart/add failed');
          // Al carrito, no al checkout: la persona revisa lo que se agrego.
          window.location.href = '/cart';
        } catch (e) {
          addBtn.textContent = 'Error. Intenta de nuevo.';
          setTimeout(() => { addBtn.textContent = originalText; addBtn.disabled = false; }, 2500);
        }
      });
    }

    resultEl.querySelector('[data-quiz-restart]')?.addEventListener('click', () => {
      Object.keys(answers).forEach((k) => delete answers[k]);
      quiz.querySelectorAll('.quiz-option.is-selected').forEach((o) => o.classList.remove('is-selected'));
      resultEl.hidden = true;
      if (nextBtn) nextBtn.hidden = false;
      if (prevBtn) prevBtn.hidden = false;
      show(0);
    });
  }

  show(0);
})();
